import vuetifyToast from 'vuetify-toast'
import { baseActions, baseMutations } from '../base'
import { apiAxios } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'
import { getTeamFilters } from '@/helpers/permissions'
import i18n from '@/i18n/i18n'

const notify = (message, type) => {
  vuetifyToast.show({
    text: message,
    color: type || 'success',
    timeout: 3000,
    icon: 'check',
  })
}

/* const filterMinorRole = (list, roles) => {
  let greaterRoles = ['all', 'president', 'coordinator']
  let filteredGreaterList = list.filter((team) =>
    roles.some(
      (role) =>
        role.objectId == team.entityId &&
        greaterRoles.includes(role.roleId.type)
    )
  )
  console.log('filteredGreaterList', filteredGreaterList)
  let filteredMinorList = list.filter(
    (team) => !filteredGreaterList.some((t) => t.value == team.value)
  )
  console.log('filteredMinorList', filteredMinorList)
  let refinedList = filteredMinorList.filter((team) =>
    roles.some((role) => role.objectId == team.value)
  )
  console.log('refinedList', refinedList)
  return refinedList.concat(filteredGreaterList)
} */

const formations = [
  '4-4-2',
  '4-3-1-2',
  '4-3-3',
  '4-2-3-1',
  '3-4-3',
  '5-3-2',
  '3-5-2',
  '5-4-1',
  '3-3',
  '3-1-2',
  '3-2-1',
  '4-2',
  '2-2-2',
  '2-3-1',
]
const positions = [
  'POR',
  'LD',
  'LI',
  'DFC',
  'DFI',
  'DFD',
  'MCD',
  'MC',
  'MCO',
  'MOI',
  'MOD',
  'MI',
  'MD',
  'MDD',
  'MDI',
  'SDD',
  'SDI',
  'EI',
  'ED',
  'DD',
  'DI',
  'DC',
  'SD',
]
const convocations = ['starting', 'substitute', 'convocated', 'noConvocated']

const initialState = () => {
  return {
    module: 'teams',
    model: 'team',
    loading: false,
    list: [],
    selectList: [],
    selected: {
      active: true,
      name: '',
      // logo: 'default-team.png',
      homeImg: '',
      entityId: {},
      categoryId: {},
      lineUp: [],
      formation: '',
      players: [],
      trainers: [],
    },
    lineUp: {
      items: [],
      groupByConvocation: {},
      groupByPositionType: {},
      groupByPosition: {},
      formation: '',
      primaryColor: '',
      secondaryColor: '',
      loading: false,
    },
    filters: {},
    idSelected: '',

    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  teamFormations() {
    return formations.map((item) => ({
      value: item,
      text: item,
    }))
  },
  teamPositions() {
    return positions.map((item) => ({
      value: item,
      text: i18n.t(`fields.teams.positions.${item}`),
    }))
  },
  teamConvocations() {
    return convocations.map((item) => ({
      value: item,
      text: i18n.t(`fields.teams.convocations.${item}`),
    }))
  },
  selectList(state) {
    return state.selectList
  },
  formatedList(state) {
    return state.list.map((item) => ({
      ...item,
      createdAt: formatDate(item.createdAt, true),
    }))
  },
}

const actions = {
  ...baseActions,
  async getOne({ commit, state }, id) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`${state.module}/${id}`)
      .finally(() => commit('setLoading', false))
    let item = data.data ? data.data[state.model] : {}
    if (Array.isArray(item.categoryId)) {
      item.categoryId = item.categoryId[item.categoryId.length - 1]
    }
    return item
  },
  async fetchList({ commit, state, rootState }, params = {}) {
    let query = {
      page: state.pagination.page,
      limit: state.pagination.rowsPerPage,
    }
    let body = Object.assign({}, params, getTeamFilters(params))
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    if (body.page) {
      query.page = body.page
      delete body.page
    }

    Object.keys(state.filters).forEach((key) => {
      if (state.filters[key] !== '' && state.filters[key] !== undefined) {
        body[key] = state.filters[key]
      }
    })

    if (rootState.entities.idSelected) {
      body.entityId = rootState.entities.idSelected
    }
    if (body.entityId) delete body._id
    if (state.selected.active !== undefined) body.active = 'all'

    if (state.pagination.sortBy) {
      query.sort = {
        [state.pagination.sortBy]: state.pagination.descending ? -1 : 1,
      }
    }
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/format', body, { params: { ...query } })
      .finally(() => commit('setLoading', false))

    commit('setPagination', {
      totalItems: data.paginate ? data.paginate.totalData : 0,
    })

    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    // let filteredList = filterMinorRole(list, rootState.auth.roles)
    commit('setList', list)
  },
  async fetchSelectList({ commit, state }, params = {}) {
    let set = true
    let query = {}
    if (params.set === false) {
      set = false
      delete params.set
    }
    let body = {}
    if (params.all) {
      delete params.all
      body = Object.assign({}, params)
    } else {
      body = Object.assign({}, params, getTeamFilters(params))
    }
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/select', body, { params: query })
      .finally(() => commit('setLoading', false))
    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    // let filteredList = filterMinorRole(list, rootState.auth.roles)
    if (set) commit('setSelectList', list)
    return list
  },
  fetchLineUpList({ commit }, teamId) {
    commit('setLineUpList', { loading: true })
    return apiAxios
      .get(`teams/${teamId}/lineUp`)
      .then(({ data }) => {
        if (!data.data) commit('resetLineUpList')
        else {
          let { lineUp, ...payload } = data.data
          commit('setLineUpList', {
            ...payload,
            items: lineUp,
          })
        }
      })
      .finally(() => commit('setLineUpList', { loading: false }))
  },
  async fetchLineUp(context, payload) {
    let { teamId, lineUpId } = payload
    let { data } = await apiAxios.get(`teams/${teamId}/lineUp/${lineUpId}`)
    let lineUp = data.data ? data.data['lineUp'] : {}
    return lineUp
  },
  async addLineUp({ dispatch }, payload) {
    let { teamId, ...params } = payload
    let { data } = await apiAxios.post(`teams/${teamId}/lineUp/add`, params)

    notify(data.message)
    dispatch('fetchLineUpList', teamId)
  },
  async updateLineUp({ dispatch }, payload) {
    let { teamId, lineUpId, ...params } = payload
    let { data } = await apiAxios.put(
      `teams/${teamId}/lineUp/${lineUpId}`,
      params
    )

    notify(data.message)
    dispatch('fetchLineUpList', teamId)
  },
  async deleteLineUp({ dispatch }, payload) {
    let { teamId, lineUpId } = payload
    let { data } = await apiAxios.delete(`teams/${teamId}/lineUp/${lineUpId}`)

    notify(data.message)
    dispatch('fetchLineUpList', teamId)
  },
}

const mutations = {
  ...baseMutations,
  setLineUpList(state, payload) {
    state.lineUp = {
      ...state.lineUp,
      ...payload,
    }
  },
  resetLineUpList(state) {
    state.lineUp = initialState().lineUp
  },
  // eslint-disable-next-line no-unused-vars
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
    state.lineUp = initialState().lineUp
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
